import type { ComponentType, FunctionComponent } from "react";
import { BsCartCheck } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Utilities
import { useAppSelector } from "../../hooks/redux.hooks";
// import { toggleCart } from '../../store/toolkit/cart/cart.slice'
import {
	selectProductsCount,
	selectProductsTotalPrice,
} from "../../store/toolkit/cart/cart.selectors";
import {
	clearCartProducts,
	toggleCart,
} from "../../store/toolkit/cart/cart.slice";
import CartItem from "../cart-item/cart-item.component";
// Components
import CustomButton from "../custom-button/custom-button.component";
// Styles
import {
	CartContainer,
	CartContent,
	CartEscapeArea,
	CartTitle,
	CartTotal,
	ClearButton,
	TotalPriceContainer,
} from "./cart.styles";

const Cart: FunctionComponent = () => {
	const BsCartCheckIcon = BsCartCheck as unknown as ComponentType<{
		size?: number;
	}>;
	const { isVisible, products } = useAppSelector((state) => state.cartReducer);

	const productsTotalPrice = useAppSelector(selectProductsTotalPrice);
	const productsCount = useAppSelector(selectProductsCount);

	const navigate = useNavigate();

	const dispatch = useDispatch();

	const handleGoToCheckoutClick = () => {
		navigate("/checkout");
		dispatch(toggleCart());
	};

	const handleClearCartClick = () => {
		dispatch(clearCartProducts());
	};

	const handleEscapeAreaClick = () => {
		dispatch(toggleCart());
	};

	return (
		<CartContainer isVisible={isVisible}>
			<CartEscapeArea onClick={handleEscapeAreaClick} />
			<CartContent>
				<CartTitle>Seu Carrinho</CartTitle>

				{products.map((product) => (
					<CartItem key={product.id} product={product} />
				))}

				{productsCount > 0 ? (
					<>
						<TotalPriceContainer>
							<CartTotal>Total: R${productsTotalPrice}</CartTotal>
							<ClearButton onClick={handleClearCartClick}>Limpar</ClearButton>
						</TotalPriceContainer>
						<CustomButton
							startIcon={<BsCartCheckIcon />}
							onClick={handleGoToCheckoutClick}
						>
							Ir para o Checkout
						</CustomButton>
					</>
				) : (
					<p>Seu carrinho está vazio!</p>
				)}
			</CartContent>
		</CartContainer>
	);
};

export default Cart;
